module.exports = __webpack_public_path__ + "static/media/synergy_logo_white_text.49354cfe.png";